<template>
<div class="users">

    <ol class="breadcrumbs">
        <router-link to="/dashboard">Dashboard</router-link> > Full Job Search
    </ol>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Full Job Search</h1>
    </div>

    <ais-instant-search :search-function="searchFunction" :search-client="searchClient" index-name="prod_JOBS">
        <ais-search-box placeholder="Search Jobs" submit-title="Search">
            <debounced-search-box :delay="200" />
        </ais-search-box>

        <ais-state-results>
            <template slot-scope="{ results: { hits, query } }">

                <ais-infinite-hits v-if="hits.length > 0 && query">

                    <table class="table focused selectable" slot-scope="{ items }">
                        <thead>
                            <tr>
                                <th class="col-date">Created</th>
                                <th class="col-job">Job#</th>
                                <th>Business</th>
                                <th>Name</th>
                                <th class="col-address">Address</th>
                                <th class="col-date">Status</th>
                                <th class="col-job">Assigned</th>
                                <th class="col-arrow"></th>
                            </tr>
                        </thead>
                        <tbody v-if="users">
                            <router-link class="rw" tag="tr" :to="{ name: 'job-view', params: { id: $options.filters.jobid(job.jobid), key: job['.key'] } }" v-for="job in items" :key="job['.key']">
                                <td class="col-date" :time="job.submitted">{{job.submitted | shortDate}}</td>
                                <td class="col-job">{{job.jobid | jobid}}</td>
                                <td>{{job.company}}</td>
                                <td :title="job.name + ' (' + job.email + ')'">{{job.name}} ({{job.email}})</td>
                                <td class="col-address">{{job.address}}</td>
                                <td class="col-date"><span style="margin:auto 0;" :style="{ background: $options.filters.statusHex(job.status)}" class="badge badge-lg">{{job.status}}</span></td>
                                <td class="col-job py-1">
                                    <div v-html="$options.filters.getCaps(job.assignedTo, job.assignedUID, users)"></div>
                                </td>
                                <td class="col-arrow"><i class="fas fa-fw fa-chevron-right"></i></td>
                            </router-link>
                        </tbody>
                    </table>
                </ais-infinite-hits>

                <div v-if="hits.length === 0 && query">
                    No results have been found for {{ query }}.
                </div>
            </template>
        </ais-state-results>

    </ais-instant-search>
</div>
</template>

<script>
import {
    db
} from "../main";
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';
import DebouncedSearchBox from '@/components/DebouncedSearchBox';

export default {
    components: {
        DebouncedSearchBox,
    },
    data() {
        return {
            users: [],
            searchClient: algoliasearch(
                'OS6EXBEUAB',
                'd97da9406933e349335792a9ba147300'
            ),
            query: null
        };
    },
    methods: {
        searchFunction(helper) {
            console.log('helper', helper)
            //if(helper.state.query.length < 2){
            //    return
            //}
            helper.search();
            this.query = helper.state.query;
        },
    },
    firebase: {
        users: db.ref('users').orderByChild('role').limitToLast(50).startAt(8),
    },
};
</script>
